import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'conversationPagePath',

})
export class ConversationPagePathPipe implements PipeTransform {
  transform(conversationDate: Date | null | undefined, conversationID: string): string {
    return getConversationPagePath(conversationDate, conversationID);
  }
}

export function getConversationPagePath(conversationDate: Date | null | undefined, conversationID: string): string {
  const septemberFirst2025 = new Date('2025-09-01T10:00:00Z');
  // For conversations (meetings) before this date, use the old v1 page
  if (!conversationDate || conversationDate < septemberFirst2025) {
    return `/meetings/meeting/${conversationID}`;
  }
  return `/meetings/meeting-v2/${conversationID}`;
}
